import Vue from 'vue'
import 'normalize.css/normalize.css'// A modern alternative to CSS resets
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'
import axios from 'axios'
import '@/styles/index.scss' // global css
import Api from './utils/request'
import shuleApi from '@/api/shule'
import App from './App'
import router from './router'
import store from './store'
import '@/icons' // icon
import '@/permission' // permission control
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '@/assets/icon/iconfont.css'
import Prints from 'vue-print-nb'
 Vue.use(Prints)
import QRCode from 'qrcodejs2';
Vue.prototype.$qrCode = QRCode
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)
Vue.use(VueQuillEditor)
Vue.prototype.$http = axios
Vue.prototype.$api = Api
Vue.prototype.$shuleApi = shuleApi
Vue.use(ElementUI, { locale })
Vue.use(VCharts)

Vue.config.devtools = true

import VueKindEditor from '@/utils/kindeditor.js'
import '../static/kindeditor/themes/default/default.css'
import '../static/kindeditor/kindeditor-all-min.js'
import '../static/kindeditor/lang/zh-CN.js'
Vue.use(VueKindEditor)

Vue.config.productionTip = false
Vue.filter('FormatMoney',function(s){
  if(s){
    s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(2) + "";
    var l = s.split(".")[0].split("").reverse(),
        r = s.split(".")[1];
    let t = "";
    for (let i = 0; i < l.length; i++) {
        t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
    }
    return t.split("").reverse().join("") + "." + r;
  } else {
    return '0.00'
  }
})
router.beforeEach((to, from, next) => {
   let token = sessionStorage.getItem('token')
    if(to.path=='/login'){
     return next()
    }else{
      if(!token){
       return next('/login')
      }else{
        next()
      }
    }
 })
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js